import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, IApplyUnmatchedInvoicesRequestDto } from '@/dtos';

import { FUNDS_HISTORY_QUERY_KEY } from './useFundsHistory.query';
import { UNAPPLIED_FUNDS_BALANCE_QUERY_KEY } from './useUnappliedFundsBalance.query';
import { UNPAID_INVOICES_QUERY_KEY } from './useUnpaidInvoices.query';

const useApplyUnmatchedInvoicesQuery = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading } = useMutation(
    (invoiceIds: string[]) =>
      api.post<unknown, unknown, IApplyUnmatchedInvoicesRequestDto>(API_URL.INVOICES_APPLY_UNMATCHED, {
        invoices_ids: invoiceIds.map(Number),
      }),
    {
      onSuccess: () => {
        void queryClient.invalidateQueries({ queryKey: [UNPAID_INVOICES_QUERY_KEY] });
        void queryClient.invalidateQueries({ queryKey: [UNAPPLIED_FUNDS_BALANCE_QUERY_KEY] });
        void queryClient.invalidateQueries({ queryKey: [FUNDS_HISTORY_QUERY_KEY] });
      },
    }
  );

  return { handleApply: mutateAsync, isLoading };
};

export default useApplyUnmatchedInvoicesQuery;
